import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {InformationDialog} from "../../_shared/dialog/information.dialog";
import {MatMenuTrigger} from "@angular/material/menu";
import {Clipboard} from "@angular/cdk/clipboard";

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
})
export class ResetPasswordComponent extends BaseComponentDirective implements OnInit {
    submitted = false;
    token = '';
    form: FormGroup = this.formBuilder.group({
        email: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', [Validators.required, Validators.minLength(8)]],
    });

    typePassword = true;
    suggestedPassword = '';

    strength: string = '';
    strengthClass: string = '';

    @ViewChild(MatMenuTrigger) matMenuTrigger!: MatMenuTrigger; // Access MatMenuTrigger

    get f() {
        return this.form.controls;
    }

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private clipboard: Clipboard
    ) {
        super(injector);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.token = this.activatedRoute.snapshot.params.token;
        this.form.controls.password.valueChanges.subscribe(r => {
            this.checkPasswordStrength();
        })
    }

    onSubmit(): void {

        this.submitted = true;
        if (this.form.invalid) {
            return;
        }

        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                message: '',
                subMessage: 'Are you sure want to change your password? Click OK to proceed',
                buttonCancelLabel: 'Cancel',
                buttonOkLabel: 'OK'

            }
        });
        dialog.componentInstance.result.subscribe(r => {
            this.submitted = true;
            const { email } = this.form.value;
            this.authService.resetPassword(
                this.form.controls.email.value,
                this.form.controls.password.value,
                this.form.controls.confirmPassword.value,
                this.token
            ).then((_) => {
                this.submitted = false;
                const dialog2 = this.dialog.open(InformationDialog, {
                    data: {
                        message: 'Your password has been updated successfully',
                        subMessage: 'Click OK button to login using your new password',
                    }
                })

                dialog2.componentInstance.result.subscribe(r => {
                    if(r) {
                        this.router.navigateByUrl('/login').then();
                    }
                })

            });
        })

    }

    copyPassword() {
        this.form.controls.password.setValue(this.suggestedPassword);
        this.form.controls.confirmPassword.setValue(this.suggestedPassword);
        this.clipboard.copy(this.suggestedPassword);
    }



    showPasswordSuggestion(event: MouseEvent) {
        this.suggestedPassword = this.ui.generateStrongPassword();
        this.matMenuTrigger.openMenu();
    }

    checkPasswordStrength(): void {
        let password = this.form.controls.password.value;

        const strengthLevels = {
            weak: { regex: /^.{0,5}$/, text: 'Weak', class: 'weak' },
            medium: { regex: /^(?=.*[A-Za-z])(?=.*\d).{6,10}$/, text: 'Medium', class: 'medium' },
            strong: { regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}$/, text: 'Strong', class: 'strong' }
        };

        if (strengthLevels.strong.regex.test(password)) {
            this.strength = strengthLevels.strong.text;
            this.strengthClass = strengthLevels.strong.class;
        } else if (strengthLevels.medium.regex.test(password)) {
            this.strength = strengthLevels.medium.text;
            this.strengthClass = strengthLevels.medium.class;
        } else {
            this.strength = strengthLevels.weak.text;
            this.strengthClass = strengthLevels.weak.class;
        }
    }
}
